import { useVoiceAssistant, useAudioWaveform } from "@livekit/components-react";
import { useEffect, useRef } from "react";

function OrbController({ orb }) {
  const { audioTrack } = useVoiceAssistant();
  const { bars } = useAudioWaveform(audioTrack, {
    barCount: 20,
    updateInterval: 50,
    volMultiplier: 1,
  });

  // Compute an average amplitude from the waveform bars.
  const averageAmplitude = bars.length > 0 ? bars.reduce((acc, val) => acc + val, 0) / bars.length : 0;

  // Calculate the target scale from the average amplitude.
  const targetScale = 0.5 + averageAmplitude;

  // Use refs to store the target scale and the smoothed scale.
  const targetScaleRef = useRef(targetScale);
  const smoothedScaleRef = useRef(0.5);

  // Update the target scale ref when the target scale changes.
  useEffect(() => {
    targetScaleRef.current = targetScale;
  }, [targetScale]);

  // Use requestAnimationFrame to smoothly update the orb's scale every frame.
  useEffect(() => {
    let animationFrameId: number;
    const alpha = 0.2;

    const animate = () => {
      // Exponential smoothing: interpolate between the current scale and the target.
      smoothedScaleRef.current = alpha * targetScaleRef.current + (1 - alpha) * smoothedScaleRef.current;

      // Update the Spline object's scale.
      if (orb.current) {
        orb.current.scale.x = smoothedScaleRef.current;
        orb.current.scale.y = smoothedScaleRef.current;
        orb.current.scale.z = smoothedScaleRef.current;
      }
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(animationFrameId);
  }, [orb]);

  return null;
}

export default OrbController;
